import { render, staticRenderFns } from "./homenew.vue?vue&type=template&id=27ca99ba&scoped=true&"
import script from "./homenew.vue?vue&type=script&lang=js&"
export * from "./homenew.vue?vue&type=script&lang=js&"
import style0 from "./homenew.vue?vue&type=style&index=0&id=27ca99ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca99ba",
  null
  
)

export default component.exports